import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { MdaiCard, type MdaiCardProps } from "./MdaiCard";

export interface CardsSectionProps {
  title?: string;
  subtitle?: string;
  description?: string | ReactElement;
  cards: MdaiCardProps[];
  closingText?: string | ReactElement;
  cardsPerRow?: { sm?: number; md?: number; lg?: number };
  cardStyle?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
}

const defaultCardStyle = {
  backgroundColor: "var(--mdai-dark-purple-2)",
  height: "100%",
};

const defaultIconStyle = {
  fill: "#fff",
  backgroundColor: "transparent",
};

export const CardsSection = ({
  title,
  subtitle,
  description,
  cards,
  closingText,
  cardsPerRow,
  cardStyle = defaultCardStyle,
  iconStyle = defaultIconStyle,
}: CardsSectionProps) => {
  return (
    <Stack alignItems={"center"} spacing={3} width={"100%"}>
      {title && <Typography variant="h3">{title}</Typography>}
      {subtitle && <Typography variant="h4">{subtitle}</Typography>}
      {typeof description === "string" ? (
        <Typography variant="body1">{description}</Typography>
      ) : (
        description
      )}
      <Grid
        container
        spacing={{ sm: 2, md: 3 }}
        columns={{
          sm: cardsPerRow?.sm ?? 1,
          md: cardsPerRow?.md ?? 2,
          lg: cardsPerRow?.lg ?? 2,
        }}
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: 1150,
          minHeight: "190px",
        }}
      >
        {cards.map((card) => (
          <Grid
            size={{ sm: 2, md: 1 }}
            key={card.title}
            alignItems={"stretch"}
            sx={{ width: "100%" }}
          >
            <MdaiCard
              card={{
                ...card,
                style: card.style ?? cardStyle,
                iconStyle: card.iconStyle ?? iconStyle,
              }}
            />
          </Grid>
        ))}
      </Grid>
      {typeof closingText === "string" ? (
        <Typography variant="body1" maxWidth={600}>
          {closingText}
        </Typography>
      ) : (
        closingText
      )}
    </Stack>
  );
};
